import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import OnboardingStep1 from './screens/Onboarding/OnboardingStep1';
import OnboardingStep2 from './screens/Onboarding/OnboardingStep2';
import OnboardingStep3 from './screens/Onboarding/OnboardingStep3';
import OnboardingStep4 from './screens/Onboarding/OnboardingStep4';
import OnboardingStep5 from './screens/Onboarding/OnboardingStep5';
import OnboardingStep6 from './screens/Onboarding/OnboardingStep6';
import OnboardingStep7 from './screens/Onboarding/OnboardingStep7';
import OnboardingStep8 from './screens/Onboarding/OnboardingStep8';
import ThankYouPage from './screens/Onboarding/ThankYouPage';
import Login from './screens/Login/Login';
import Overview from './screens/Dashboard/Overview';
import CompanyDetails from './screens/Dashboard/CompanyDetails';
import Policies from './screens/Dashboard/Policies';
import PPPolicy from './screens/Dashboard/PPPolicy';
import ClaimsHistory from './screens/Dashboard/ClaimsHistory';
import Profile from './screens/Dashboard/Profile';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './styles/fonts.css';
import storage from './utils/storage';
import { OrganizationProvider } from './contexts/OrganizationContext';

function App() {
  useEffect(() => {
    storage.initSessionListener();
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/dashboard/*" element={
            <ProtectedRoute>
              <OrganizationProvider>
                <Routes>
                  <Route path="/" element={<Overview />} />
                  <Route path="/company" element={<CompanyDetails />} />
                  <Route path="/policies" element={<Policies />} />
                  <Route path="/pp-policy" element={<PPPolicy />} />
                  <Route path="/claims-history" element={<ClaimsHistory />} />
                  <Route path="/profile" element={<Profile />} />
                </Routes>
              </OrganizationProvider>
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/onboarding/step-one" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/onboarding/step-one" element={<OnboardingStep1 />} />
          <Route path="/onboarding/step-two" element={<OnboardingStep2 />} />
          <Route path="/onboarding/step-three" element={<OnboardingStep3 />} />
          <Route path="/onboarding/step-four" element={<OnboardingStep4 />} />
          <Route path="/onboarding/step-five" element={<OnboardingStep5 />} />
          <Route path="/onboarding/step-six" element={<OnboardingStep6 />} />
          <Route path="/onboarding/step-seven" element={<OnboardingStep7 />} />
          <Route path="/onboarding/step-eight" element={<OnboardingStep8 />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App; 